import { Outlet, useParams } from 'react-router-dom';
import { ErrorDisplay } from '@/modules/shared/components/ui/ErrorDisplay';

export default function ProgramContextLayout() {
  const { programId } = useParams<{ programId?: string }>();

  if (!programId) {
    return (
      <div className="mx-auto flex min-h-screen w-full max-w-[1280px] items-start px-4 py-4">
        <div className="w-full">
          <ErrorDisplay message="Program context is missing from the route. Please reopen the page from the Programs menu." />
        </div>
      </div>
    );
  }

  return <Outlet />;
}